import type { ExtensionComponents } from '@atlassian/conversation-assistant-widget/common/utils/extension-components-context/types';

export const importTwilioExtensionComponents = (): Promise<ExtensionComponents> => {
	return import('@atlassian/conversation-assistant-widget/twilio-extension-components').then(
		({ TwilioExtensionComponents }) => {
			return TwilioExtensionComponents;
		},
	);
};
